// extracted by mini-css-extract-plugin
module.exports = {"detail":"DetailEdit_detail_ldjC2","label-tag":"DetailEdit_label-tag_3CqJn"};